import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { watchupdateadvisorSaga } from './saga';
import { FailureResponse } from 'types/api';
import { UpdateAdvisorState } from './types';
// import { UpdateAdvisorState } from './types';

export const initialState: UpdateAdvisorState = {
  isLoading: false,
  failureResponse: null,
  successResponse: null,
};

const slice = createSlice({
  name: 'updateAdvisor',
  initialState,
  reducers: {
    updateAdvisor(state, action: PayloadAction<any>) {
      state.isLoading = true;
    },
    createAdvisorSuccess(state, action: PayloadAction<any>) {
      state.isLoading = false;
      state.successResponse = action.payload;
    },
    createAdvisorFailed(state, action: PayloadAction<FailureResponse | null>) {
      state.isLoading = false;
      state.failureResponse = action.payload;
    },
    createAdvisorReset(state) {
      state.isLoading = false;
      state.failureResponse = null;
      state.successResponse = null;
    },
  },
});

export const { actions: advisorActions } = slice;

export const useUpdateAdvisorSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: watchupdateadvisorSaga });
  return { actions: slice.actions };
};
